var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "admin-app-notification-modal",
        title: "App Notification",
        "hide-footer": "",
        centered: "",
      },
      model: {
        value: _vm.modalOpened,
        callback: function ($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened",
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submitForm.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Notification Title" } },
            [
              _c("b-form-input", {
                attrs: {
                  type: "text",
                  state: _vm.fieldValid("title"),
                  disabled: _vm.isDisabled,
                },
                model: {
                  value: _vm.formData.title,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formData,
                      "title",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "formData.title",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("title") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("title")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Is title hidden?" } },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: {
                    state: _vm.fieldValid("is_title_hidden"),
                    disabled: _vm.isDisabled,
                  },
                  model: {
                    value: _vm.formData.is_title_hidden,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "is_title_hidden", $$v)
                    },
                    expression: "formData.is_title_hidden",
                  },
                },
                [_vm._v("\n        Yes\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("is_title_hidden") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("is_title_hidden")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("i", [_vm._v("Hidden titles are not displayed to the users")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Notification Content" } },
            [
              !_vm.isDisabled
                ? _c("vue-editor", {
                    attrs: { "editor-toolbar": _vm.editorToolbar },
                    model: {
                      value: _vm.formData.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "content", $$v)
                      },
                      expression: "formData.content",
                    },
                  })
                : _c("div", {
                    staticClass: "notification-content-preview",
                    domProps: { innerHTML: _vm._s(_vm.formData.content) },
                  }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("content") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("content")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Level" } },
            [
              _c(
                "b-dropdown",
                {
                  staticClass: "level-btn",
                  attrs: {
                    text: _vm.levelBtnText,
                    block: "",
                    variant: _vm.levelBtnVariant,
                    "menu-class": "w-100",
                    disabled: _vm.isDisabled,
                  },
                },
                [
                  _c(
                    "b-dropdown-item",
                    {
                      on: {
                        click: function ($event) {
                          _vm.formData.level = null
                        },
                      },
                    },
                    [_vm._v("Default")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "link-class": "bg-success level-btn-item" },
                      on: {
                        click: function ($event) {
                          _vm.formData.level = "success"
                        },
                      },
                    },
                    [_vm._v("Success")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "link-class": "bg-info level-btn-item" },
                      on: {
                        click: function ($event) {
                          _vm.formData.level = "info"
                        },
                      },
                    },
                    [_vm._v("Info")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "link-class": "bg-warning level-btn-item" },
                      on: {
                        click: function ($event) {
                          _vm.formData.level = "warning"
                        },
                      },
                    },
                    [_vm._v("Warning")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    {
                      attrs: { "link-class": "bg-danger level-btn-item" },
                      on: {
                        click: function ($event) {
                          _vm.formData.level = "error"
                        },
                      },
                    },
                    [_vm._v("Error")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("level") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("level")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Is fixed?" } },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: {
                    state: _vm.fieldValid("is_fixed"),
                    disabled: _vm.isDisabled,
                  },
                  model: {
                    value: _vm.formData.is_fixed,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "is_fixed", $$v)
                    },
                    expression: "formData.is_fixed",
                  },
                },
                [_vm._v("\n        Yes\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("is_fixed") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("is_fixed")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("i", [_vm._v("Fixed notifications cannot be dismissed")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "Start Date" } },
            [
              _c("b-form-datepicker", {
                staticClass: "notification-datepicker",
                attrs: {
                  "date-format-options": {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                  },
                  locale: "en-US",
                  "label-no-date-selected": "No start date",
                  "today-button": "",
                  "reset-button": "",
                  "close-button": "",
                  "label-today-button": "Today",
                  "label-reset-button": "Clear",
                  state: _vm.fieldValid("start_date"),
                  disabled: _vm.isDisabled,
                },
                model: {
                  value: _vm.formData.start_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "start_date", $$v)
                  },
                  expression: "formData.start_date",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("start_date") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("start_date")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("i", [
                _vm._v("Leave empty to activate notification immediately"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            { attrs: { label: "End Date" } },
            [
              _c("b-form-datepicker", {
                staticClass: "notification-datepicker",
                attrs: {
                  "date-format-options": {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                  },
                  locale: "en-US",
                  "label-no-date-selected": "No end date",
                  "today-button": "",
                  "reset-button": "",
                  "close-button": "",
                  "label-today-button": "Today",
                  "label-reset-button": "Clear",
                  state: _vm.fieldValid("end_date"),
                  disabled: _vm.isDisabled,
                },
                model: {
                  value: _vm.formData.end_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "end_date", $$v)
                  },
                  expression: "formData.end_date",
                },
              }),
              _vm._v(" "),
              _c(
                "b-form-invalid-feedback",
                { attrs: { state: _vm.fieldValid("end_date") } },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getFieldError("end_date")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("i", [
                _vm._v("Leave empty to keep notification active forever"),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.deleted
            ? _c(
                "no-permission-wrapper",
                { attrs: { show: _vm.forbidden } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: _vm.formProcessing || _vm.isDisabled,
                      },
                      on: { click: _vm.submitForm },
                    },
                    [
                      _vm._v("\n        Save Notification\n        "),
                      _vm.formProcessing
                        ? _c("b-spinner", {
                            staticClass: "ml-1",
                            attrs: { small: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-btn",
            {
              attrs: { type: "button", variant: "secondary" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.modalOpened = false
                },
              },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }